export type NoteRequestBody = {
  note: string;
};
